import { LocalizationProvider as Provider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { ptBR } from 'date-fns/locale';

const LocalizationProvider = (
  { children }: { children: React.ReactNode },
): JSX.Element => (
  <Provider
    dateAdapter={AdapterDateFns}
    adapterLocale={ptBR}
    localeText={{
      fieldYearPlaceholder: () => 'AAAA',
    }}
  >
    {children}
  </Provider>
);

export default LocalizationProvider;
